import api from "./apiBase";

function sendPrintProof(orderId, formData) {
  return api.post(`/print-proofs/${orderId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function getPrintProof(orderId) {
  return api.get(`/print-proofs/${orderId}`);
}

export {
  sendPrintProof,
  getPrintProof,
}